import React from 'react';

import { ArrowDown } from '../../icons';
import { StyledArrow, StyledButton } from './Accordion.styles';
import { IAccordionButtonProps } from './Accordion.types';

const AccordionButton = ({
  active,
  ariaLabel,
  id,
  title,
  onClick,
  onKeyDown,
}: IAccordionButtonProps): JSX.Element => {
  return (
    <StyledButton
      aria-controls={`accordionpanel_${id}`}
      aria-expanded={active ? 'true' : 'false'}
      id={`accordion_${id}`}
      role="button"
      title={ariaLabel}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {title}
      <StyledArrow>
        <ArrowDown />
      </StyledArrow>
    </StyledButton>
  );
};

export default AccordionButton;
